'use client';

import { LeftArrowOutlined, RightArrowOutlined } from '@zeelool/icon';
import React from 'react';
// CSS已合并到 globals.css，无需单独导入

interface SwiperNavigationButtonsProps {
  prevButtonRef?: React.Ref<HTMLButtonElement>;
  nextButtonRef?: React.Ref<HTMLButtonElement>;
  prevIcon?: React.ReactNode;
  nextIcon?: React.ReactNode;
  prevButtonClassName?: string;
  nextButtonClassName?: string;
  prevButtonPosition?: string;
  nextButtonPosition?: string;
  // 自定义导航按钮选择器前缀，用于区分不同的 Swiper 实例
  navigationPrefix?: string;
  iconStyle?: React.CSSProperties;
}

const SwiperNavigationButtons: React.FC<SwiperNavigationButtonsProps> = ({
  prevButtonRef,
  nextButtonRef,
  prevIcon,
  nextIcon,
  prevButtonClassName = '',
  nextButtonClassName = '',
  prevButtonPosition = 'left-16',
  nextButtonPosition = 'right-16',
  navigationPrefix = 'swiper-nav',
  iconStyle = {},
}) => {
  // 生成唯一的导航按钮类名
  const prevButtonClass = `${navigationPrefix}-prev`;
  const nextButtonClass = `${navigationPrefix}-next`;

  return (
    <>
      {/* Previous Button */}
      <button
        ref={prevButtonRef}
        type="button"
        aria-label="Previous slide"
        className={`${prevButtonClass} swiper-nav-button swiper-nav-prev absolute border-0 bg-transparent p-0 ${prevButtonPosition} ${prevButtonClassName}`}
      >
        {prevIcon ?? (
          <LeftArrowOutlined className="swiper-nav-icon" style={iconStyle} aria-hidden />
        )}
      </button>

      {/* Next Button */}
      <button
        ref={nextButtonRef}
        type="button"
        aria-label="Next slide"
        className={`${nextButtonClass} swiper-nav-button swiper-nav-next absolute border-0 bg-transparent p-0 ${nextButtonPosition} ${nextButtonClassName}`}
      >
        {nextIcon ?? (
          <RightArrowOutlined className="swiper-nav-icon" style={iconStyle} aria-hidden />
        )}
      </button>
    </>
  );
};

export default SwiperNavigationButtons;
